export const SCROLL_CONTAINER_ID = 'scroll-to-top'; //taken from project list providers remote

export const EXO_SKELETON_SCOPE_NAME = 'ACCExoSkeleton';
export const IMPORT_REMOTE_RUNTIME_EVENT_NAME = 'IMPORT_REMOTE_LOADED';

export const SERVICE_WORKER_CLEAN_CACHE_EVENT_NAME =
  'exo-skeleton:service-worker:clean-cache';

export const MFA_BANNER_SESSION_STORAGE_KEY = 'mfa-setup-banner';

// Self-serve service-worker opt-out for the ?exoSw=on|off override. Shared
// from here so the app and its tests reference one key.
export const SERVICE_WORKER_OVERRIDE_STORAGE_KEY = 'EXO_SW_OVERRIDE';

/* Set on <html> by the entry point once the bootstrap import has a handler
 * attached, and read by the static loader's timer to decide whether the
 * recovery screen is still needed. Both sides must agree on the literal, or the
 * timer fires on every page load. */
export const BOOTSTRAP_HANDLER_READY_ATTRIBUTE =
  'data-exo-bootstrap-handler-ready';

/* Read from the entry chunk, which must not import `utils/monitoring` — that
 * would pull the monitoring graph into the pre-bootstrap bundle. Re-exported
 * into `REPORT_EVENT_TYPES` so the Dynatrace registry stays complete. */
export const BOOTSTRAP_LOAD_ERROR_EVENT_TYPE = 'bootstrap-load-error';

// Shared by the pre-bootstrap and React recovery dialogs so one tab session
// has a single display budget regardless of which path rendered the dialog.
export const LOADING_PROBLEM_MODAL_DISPLAY_COUNT_KEY =
  'exo-loading-problem-modal-display-count';
export const MAX_LOADING_PROBLEM_MODAL_DISPLAYS_PER_SESSION = 2;

// One flag per deferred remote, so each rolls out and reverts on its own.
// Shared from here because both root layouts render the trial banner, and the
// e2e coverage needs the same keys to force gating on.
export const DEFER_TRIAL_BANNER_FLAG = 'defer-trial-banner';
export const DEFER_ASSISTANT_IN_TOP_NAV_FLAG = 'defer-assistant-in-top-nav';

// Reported once per deferred remote that IDLE_TIMEOUT_IN_MS released before
// the active tool signaled ready, so a QA measurement can tell the two apart.
// Shared from here because the e2e listens for the same message.
export const DEFERRED_REMOTE_RELEASED_BY_CEILING =
  'deferred-remote-released-by-ceiling';

// used for e2e tests
export const LOCAL_URL = new URL('https://local.acc-qa.autodesk.com:3000/');
